"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Main_1 = __importDefault(require("@/components/Main"));
const UsersTable_1 = __importDefault(require("../UsersTable"));
const UsersFilter_1 = __importDefault(require("../UsersFilter"));
const style_1 = require("./style");
function UsersTableSectionView() {
    return (react_1.default.createElement(Main_1.default, { testId: "users-main" },
        react_1.default.createElement(style_1.FilterWrapper, null,
            react_1.default.createElement(UsersFilter_1.default, null)),
        react_1.default.createElement(UsersTable_1.default, null)));
}
exports.default = UsersTableSectionView;
